export default __webpack_public_path__ + "static/media/no77SharkClosed.1dad125b.jpg";